import React from 'react';
import PropTypes from 'prop-types';
import { Capacitor } from '@capacitor/core';
import { ButtonBase, ListItem, Typography } from '@mui/material';
import { Help } from '@/resources/icons';
import useFreshDeskWidget from '@/hooks/useFreshDeskWidget';
import useStyles from './styles';

const FreshdeskMenuItem = ({ handleMenuClose }) => {
    const classes = useStyles();
    const isIos = Capacitor.getPlatform() === 'ios';
    const { openFreshDeskWidget } = useFreshDeskWidget();

    if (isIos) {
        return null;
    }

    return (
        <ListItem className={`${classes.listItem} ${classes.zenDeskBase}`}>
            <ButtonBase
                className={classes.zenDeskHelpButton}
                onClick={() => {
                    openFreshDeskWidget();
                    handleMenuClose();
                }}
                color="primary"
                variant="contained"
            >
                <div className={classes.zenDeskHelpInnerContent}>
                    <Help className={classes.zenDeskHelpIcon} />
                    <Typography variant="body2">Help</Typography>
                </div>
            </ButtonBase>
        </ListItem>
    );
};

FreshdeskMenuItem.propTypes = {
    handleMenuClose: PropTypes.func.isRequired
};

export default FreshdeskMenuItem;
